<template>
  <div class="page" v-if="isShowHead">
        <div class="topbar">
            <div class="content">
                <span class="welcome">您好，欢迎访问{{title}}！</span>
                <ul>
                    <li><a href="#" class="on" v-if="!isLogined" @click="toLogin" >亲，请登录</a></li>
                    <li><a href="#" @click="toHomePage" >首页</a></li>                   
                    <li><a href="#" @click="toMyAddress()" >收货地址</a></li>
                    <li><a href="#" @click="toMyOrder()">我的订单</a></li>
                    <li class="dropdown" v-if="isLogined">
                      <span class="dropdown-title">个人中心<i class="icon icon-down"></i></span>
                      <div class="dropdown-content">
                        <div class="dropdown-menu">
                          <div class="menuItem" @click="toMyOrder()">我的订单</div>
                          <div class="menuItem" @click="toMyAddress()">收货地址</div>
                          <div class="menuItem" @click="toMyCollect()">商品收藏</div>
                          <div class="menuItem" @click="toMyCollect1()">店铺收藏</div>
                          <div class="menuItem" @click="toResetPassword()">修改密码</div>
                          <div class="menuItem" @click="loginOut()">退出登录</div>
                         </div>
                      </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="head">
            <div class="content">
                <div :class="filingsType==1?'logo':('logo'+filingsType)" @click="toHomePage()"></div>
                <div class="search">
                    <select v-model="searchType">
                      <option value="0">宝贝</option>
                      <option value="1">品牌</option>
                      <option value="2">店铺</option>
                    </select>
                    <input type="text" v-model.trim="input" placeholder="请输入搜索内容" @keyup.enter="toSearch" />
                    <div class="searchbtn" href="#" @click="toSearch()">搜索</div>
                    <div class="shopcarbtn" href="#" @click="toCart()">我的购物车</div>
                </div>
            </div>
        </div>
        <div class="banner" v-if="isShowNavigation">
            <div class="content">
                <ul>
                    <li :class="navigationId==-1?'on':''"  @click="selectNavigation({id:-1})">
                        商城首页
                    </li>   
                    <li v-for="(item,i) in navigationList" :key="'navigation_'+i" :class="navigationId==item.id?'on':''" @click="selectNavigation({id:item.id,name:item.title})" >
                        {{item.title}}
                    </li>                           
                </ul>
            </div>
        </div>
  </div>
</template>
<style>
@import '../../styles/head.css';
</style>
<script>
import api from '@/api'
import { getNavigations } from '@/api/homePage'
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'
import YButton from '@/components/yButton'
import { setStore, getStore, removeStore } from '@/utils/storage'
import { getTitle } from '@/api/homePage'
export default {
  name: 'heads',
  components: {
    YButton
  },
  computed: {
    ...mapState([
      'isLogined',
      'profile',
      'cartList', 
      'receiveInCart', 
      'showCart',
      'goods',
      'goodsTotal'
    ]),
    
    // 计算价格
    totalPrice () {
      var totalPrice = 0
      this.cartList && this.cartList.forEach(item => {
        totalPrice += (item.num * item.settlementPrice)
      })
      return totalPrice
      
    },
    // 计算数量
    totalNum () {
      var totalNum = 0
      this.cartList && this.cartList.forEach(item => {
        totalNum += (item.num)
      })
      return totalNum
    }
  },
  data() {
    return {
      isShowNavigation:false,
      navigationId:-1,
      // 是否已经加载过用户信息
      isLoaded: false,
      createDialogVisible: false,
      router:this.$router.currentRoute.path,
    
      input: '',
      searchResults: [],
      timeout: null,
      navigationList:[],
      keyType:0,
      title:'军缘融通',
      isShowHead:true,
      searchType:'0',
      filingsType:1
    }
  },
  created() {  
    var tempNavigationId = this.$route.query.navigationId;
    if (tempNavigationId||parseInt(tempNavigationId)>=0) {
        this.navigationId = parseInt(tempNavigationId)
      }else
      {
        this.navigationId=-1;
      }      
    if (this.$route.query.key) {
      this.input = this.$route.query.key
    }
    if (this.$route.query.searchType) {
      this.searchType = this.$route.query.searchType
    }
    var tempUrl = window.location.href.toUpperCase();    
    tempUrl = tempUrl.split('?')[0];
    if(tempUrl.indexOf('LOGINRESULT')!=-1)
    {
      this.isShowHead=false;
    }
    if(tempUrl.indexOf('HOME')!=-1||tempUrl.indexOf('MAINCATE')!=-1||tempUrl.indexOf('GOODSDETAILS')!=-1||tempUrl.indexOf('SEARCH')!=-1)
    {
      this.isShowNavigation=true;
      this._getNavigations();
    }            
    if(tempUrl.indexOf('FJJYKJ.COM.CN')!=-1)
    {
       this.filingsType = 1;
       this.title = '军缘融通';
    }
    if(tempUrl.indexOf('JUNYUANGO.COM')!=-1)
    {
       this.filingsType = 4;
       this.title = '军缘优购';
    }
    if(tempUrl.indexOf('XUXINGTRIP.COM')!=-1)
    {
       this.filingsType = 5;
       this.title = '徐行九州';
    }
    if(tempUrl.indexOf('LEHUILIFE.COM.CN')!=-1)
    {
       this.filingsType = 6;
       this.title = '乐惠车生活';
    }
  },
  mounted () {
      // this._getTitle();
    },
  methods: {
    // async _getTitle()
    // {
    //   // var tempTitle = localStorage.getItem('supplierTitle');  
    //   // if(tempTitle==''||tempTitle==null||tempTitle==undefined)
    //   // {
    //   //   await getTitle().then(res=>{
    //   //       this.title = res.data.result;
    //   //       localStorage.setItem('supplierTitle', this.title);            
    //   //   });
    //   // }
    //   // else
    //   // {
    //   //   this.title = tempTitle;
    //   // }
    // },
    selectNavigation(val)
    {
       this.navigationId = val.id;
       if(val.id==-1)
       {
         this.$router.push({ path: '/home' })
       }
       else
       {
        var name = encodeURIComponent(val.name);
        //this.$router.push({ path: '/search', query:{ mainCate: this.navigationId,mainCateName : name } })
        this.$router.push({ name: 'search', query:{sort:0, navigationId: this.navigationId} })
       }
    },   
    toLogin() {
        this.$router.push({ name: 'userLogin' })
      },
    toSearch()
    {     
      if(this.input==null||this.input==''||this.input==undefined)
      {      
        this.$router.push({ path: '/search', query: { searchType:this.searchType } })
      }
      else 
      {
        this.$router.push({ path: '/search', query: { key: this.input, searchType:this.searchType } })
      }
    },
    toHomePage()
    {
      this.$router.push({ path: '/home' })
    },
    toResetPassword()
    {
       this.$router.push({ path: '/user/updatePassword' })
    },
    toMyOrder()
    {
       this.$router.push({ path: '/user/orderList' })
    },
     toMyAddress()
     {
       this.$router.push({ path: '/user/addressList' })
     },
     toMyCollect()
     {
      this.$router.push({ path: '/user/collectProductList' })
     },
     toMyCollect1()
     {
      this.$router.push({ path: '/user/collectSupplierList' })
     },
     toUser()
     {
        this.$router.push({ path: '/user' })
     },    
      toCart () {
        this.$router.push({path: '/cart'})
      },
      // 退出登陆
      async loginOut () {
        await this.logout()
        removeStore('buyCart')
        window.localStorage.removeItem('ACCESS_TOKEN')
        this.$router.push({ name: 'userLogin' })
      },
      goIndex () {
        window.location.href = '/'
      },
      async _getNavigations()
      {
        await getNavigations().then(res=>{           
            this.navigationList = res.data.result
        })       
      },
    ...mapActions([
      'logout'
    ]),
  }
}
</script>


// WEBPACK FOOTER //
// index.vue?4ffbb4da